// 科学的介護推進に関する評価の定数
export const LOADING = 'SCIENTIFIC_NURSING_CARE_PROMOTION_API_LOADING';
export const SUCCESS = 'SCIENTIFIC_NURSING_CARE_PROMOTION_API_SUCCESS';
export const ERROR = 'SCIENTIFIC_NURSING_CARE_PROMOTION_API_ERROR';
export const FINISH = 'SCIENTIFIC_NURSING_CARE_PROMOTION_API_FINISH';

// 科学的介護推進に関する評価のデータ型
export interface UsersWithData {
  [key: string]: boolean;
}

export interface ScientificNursingCarePromotionData {
  usersWithData: UsersWithData;
}
